import { createApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import { nextTick } from 'vue';
import ContactUs from "./components/contactus-component.vue";
import App from './App.vue';


const routes = [
    { path: '/contactus', name: 'ContactUs', component: ContactUs },
    // more routes...
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

router.afterEach(async (to) => {
    // Use nextTick to wait for the DOM to update
    await nextTick();
    if(to.hash){
        const element =  document.querySelector(to.hash);
        element?.scrollIntoView({ behavior: 'smooth' });
    }

});

const app = createApp(App);
app.use(router);
app.mount('#app');
